<template>
  <div>
    <template v-for="format in formatOptions">
      <wt-radio-box
        :key="format.value"
        group="format-options-group"
        :selected="format.value === contextFilters.format"
        :value="format.value"
        :labelRight="format.label"
        @select="formatFilterChanged"
        v-if="checkIfCustomAllow(format)"
      />
    </template>
  </div>
</template>

<script>
import app from 'app';
export default app.Vue.extend({
  data() {
    return {
      formatOptions: [
        {
          label: 'All',
          value: null,
        },
        {
          label: 'Videos',
          value: 'VIDEO',
        },
        {
          label: 'Images',
          value: 'IMAGE',
        },
        {
          label: 'Infographics',
          value: 'INFOGFX',
        },
        {
          label: 'GIFs',
          value: 'GIF',
        },
        {
          label: 'Instagram',
          value: 'INSTAGRAM',
          custom: true,
        },
        {
          label: 'Twitter',
          value: 'TWITTER',
          custom: true,
        },
      ],
    };
  },

  computed: Object.assign({}, app.Vuex.mapGetters(['contextFilters'])),

  props: {
    customFormats: {
      type: Object,
      default: {},
    },
  },
  created() {
    if (this.searchContextId() === app.PROVIDERS.FAVORITES.id) {
      this.formatOptions = this.formatOptions.map((f) =>
        f.value !== 'INFOGFX'
          ? f
          : {
              label: 'Infographics',
              value: 'MAP|WEBPAGE',
            }
      );
    }
  },
  methods: Object.assign(
    {
      checkIfCustomAllow(format) {
        return !format.custom || !!this.customFormats[format.value];
      },
      formatFilterChanged(value) {
        this.SET_FORMAT_FILTER_SELECTION(value);
        this.$emit('search');
      },
    },
    app.Vuex.mapState({
      searchContextId: (state) => state.assetGallery.searchContextId,
    }),
    app.Vuex.mapActions(['SET_FORMAT_FILTER_SELECTION'])
  ),
});
</script>
